var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui longer flip small modal scanner"},[_c('ScannerMain',{attrs:{"is_modal":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }